const data = [
    { id: 1, name: "Inclusão" },
    { id: 2, name: "Revisão" },
    { id: 3, name: "Revisão"},
    { id: 4, name: "Devedora"}
  ];
  
export default [...data];